"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Whirlpool = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Whirlpool = function Whirlpool(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({
    transform: "rotate(0)"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.91,9c-2.23,0-6-.43-6-2s3.77-2,6-2,6,.42,6,2S14.14,9,11.91,9Zm0-3c-3,0-4.87.66-5,1,.13.31,2,1,5,1s4.86-.67,5-1C16.77,6.61,14.93,6,11.91,6Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.91,18c-1.45,0-3-.47-3-1.5a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5,3,3,0,0,0,2,.5,2.8,2.8,0,0,0,2-.53.49.49,0,0,1,.5-.49.51.51,0,0,1,.5.52C14.91,17.48,13.35,18,11.91,18Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.32,11.94c-1,0-2.41-.53-2.41-1.48a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5,2.16,2.16,0,0,0,1.41.48.5.5,0,0,1,.5.5A.51.51,0,0,1,9.32,11.94Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,12.19l-.61,0a.5.5,0,0,1-.48-.52.51.51,0,0,1,.52-.47c2.59.11,4.21-.53,4.49-.83a.49.49,0,0,1,.49-.4.5.5,0,0,1,.5.5.85.85,0,0,1-.3.62C16,11.65,14.26,12.19,12,12.19Zm3.91-1.74Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.41,14.94a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5.85.85,0,0,0,.51-.36.47.47,0,0,1,.49-.46.53.53,0,0,1,.5.53C15.91,14.29,15,14.94,14.41,14.94Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.88,15.21a5.53,5.53,0,0,1-3.62-1.08.93.93,0,0,1-.35-.68.5.5,0,0,1,.5-.5.49.49,0,0,1,.49.41,4.56,4.56,0,0,0,3.31.84.52.52,0,0,1,.52.48.5.5,0,0,1-.48.52Zm-3-1.76Zm0-.11"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fillOpacity: "0",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }));
};

exports.Whirlpool = Whirlpool;